import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-vh-100 d-flex align-items-center bg-light">
      <Container>
        <Row className="justify-content-center text-center">
          <Col lg={8}>
            <h1 className="display-1 fw-bold text-primary mb-3">404</h1>
            <h2 className="h3 mb-4">Page Not Found</h2>
            <p className="lead text-muted mb-4">
              Sorry, the page you're looking for doesn't exist or has been moved.
            </p>
            <Button 
              variant="primary" 
              size="lg" 
              onClick={() => navigate('/')}
            >
              Back to Home
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NotFound;
